import { DataError, type DataErrorCode, type RegistrationResult } from "./provider";

/**
 * Thrown by registerDevices when a batch fails part-way (the API registers one device per
 * database call and answers 207 with the ones that succeeded). The devices registered before
 * the failure keep their one-time secrets here so the UI can still show and export them.
 */
export class PartialRegistrationError extends DataError {
  constructor(
    code: DataErrorCode,
    public readonly registered: RegistrationResult[],
    public readonly failedDeviceId: string,
    message?: string,
  ) {
    super(code, message);
    this.name = "PartialRegistrationError";
  }
}
